import { useEffect } from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

export function Modal({ open, onClose, title, children }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="bg-on-surface/40 absolute inset-0 backdrop-blur-sm" onClick={onClose} />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'modal-title' : undefined}
        className="bg-surface border-line no-scrollbar relative z-10 max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-lg border shadow-xl"
      >
        <div
          className={
            title
              ? 'border-line flex items-center justify-between border-b p-5'
              : 'flex items-center justify-end p-3'
          }
        >
          {title && (
            <h2 id="modal-title" className="font-headline text-on-surface text-lg font-bold">
              {title}
            </h2>
          )}
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className="text-on-surface-light hover:text-on-surface transition-colors"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className={title ? 'p-5' : 'px-5 pb-5'}>{children}</div>
      </div>
    </div>
  );
}
